export default "__VITE_ASSET__ygrOgxhy__"